import { LitElement, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import style from './style/zaptic-select-box-style'

@customElement('zaptic-select-box')
export class SelectBox extends LitElement {
    static styles = style

    @property({ type: Boolean })
    open = false

    @property({ type: Boolean })
    disabled = false

    @property({ type: Boolean })
    invalid = false

    @property({ type: Boolean })
    hideChevron = false

    @property({ type: Boolean })
    readonly: boolean

    render() {
        return html`
            <div class="box ${classMap({ disabled: this.disabled, invalid: this.invalid, readonly: this.readonly })}">
                <slot></slot>

                <zaptic-rotating-chevron
                    direction="${this.open ? 'up' : 'down'}"
                    ?hidden="${this.hideChevron ? true : false}"
                ></zaptic-rotating-chevron>
            </div>
        `
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'zaptic-select-box': SelectBox
    }
}
